import { App } from "@/shared/app";

export const plmApp: App = {
  title: "PLM",
  route: "plm",
};
